// @flow

import { dispatch, getState } from 'redux/store'
import { setVars } from 'redux/action'

export function getActionNum (): number {
  return getState().vars.easyActionNum || 0
}

export function updateActionNum () {
  dispatch(setVars('easyActionNum', getActionNum() + 1))
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/redux/action-num.js